module.exports = __webpack_public_path__ + "static/media/news2.28d31dea.jpg";